import { Modal } from 'antd';
import styled from 'styled-components';

export const PhotoWrapper = styled.div`
  padding: 2rem;
  display: flex;
  flex-direction: column;
  width: 100%;

  .photo_header {
    position: relative;
    display: flex;
    align-items: center;
    margin-bottom: 24px;

    button.photo_back-btn {
      display: flex;
      align-items: center;
      gap: 6px;
      background: #edeff1;
      border: none;
      border-radius: 8px;
      height: 40px;
      padding: 0 16px;
      cursor: pointer;
      font-size: var(--font-size-base);
      font-weight: var(--font-medium);
      color: var(--color-text-primary, #111827);
      transition: background 0.2s;
      position: relative;
      z-index: 1;

      &:hover {
        background: #dde1e5;
      }
    }

    h1 {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      text-align: center;
      white-space: nowrap;
      font-weight: var(--font-bold);
      line-height: 46px;
      margin: 0;
    }
  }

  .photo_section {
    border: 1px solid var(--color-border-primary, #e5e7eb);
    border-radius: 8px;
    padding: 20px 24px;
    margin-bottom: 20px;

    .photo_section-title {
      font-size: var(--font-size-sm);
      font-weight: var(--font-medium);
      color: var(--color-text-secondary, #6b7280);
      margin-bottom: 16px;
      padding-bottom: 8px;
      border-bottom: 1px solid var(--color-border-primary, #e5e7eb);
    }
  }

  .photo_footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding-top: 8px;

    .ant-btn {
      height: 48px;
      min-width: 120px;
      font-weight: var(--font-bold);
      border-radius: 8px;
    }

    .ant-btn-default {
      color: var(--color-primary, #1677ff);
      border-color: var(--color-primary, #1677ff);
    }
  }

  .photo_thumbnail-header {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 16px;
  }
`;

export const AssetInfoPanel = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px 32px;

  .asset-info_item {
    display: flex;
    flex-direction: column;
    gap: 4px;

    .asset-info_label {
      font-size: var(--font-size-sm);
      color: var(--color-text-secondary, #6b7280);
      font-weight: var(--font-medium);
    }

    .asset-info_value {
      background: #f3f4f6;
      border: 1px solid var(--color-border-primary, #e5e7eb);
      border-radius: 6px;
      padding: 10px 14px;
      font-size: var(--font-size-base);
      font-weight: var(--font-medium);
      color: var(--color-text-primary, #111827);
      min-height: 42px;
      display: flex;
      align-items: center;
    }
  }
`;

export const PhotoCountBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: var(--font-size-base);
  font-weight: var(--font-medium);
  color: var(--color-text-secondary, #6b7280);

  strong {
    font-size: 1.1rem;
    color: var(--color-text-primary, #111827);
  }
`;

export const ThumbnailGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
`;

export const ThumbnailCard = styled.div`
  display: flex;
  flex-direction: column;
  border: 2px solid var(--color-border-primary, #e5e7eb);
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s;

  &:hover {
    border-color: var(--color-primary, #1677ff);
    box-shadow: 0 2px 8px rgba(22, 119, 255, 0.15);
  }
`;

export const ThumbnailImage = styled.img`
  width: 100%;
  height: 200px;
  object-fit: cover;
  display: block;
  background: #f3f4f6;
`;

export const ThumbnailImageError = styled.div`
  width: 100%;
  height: 200px;
  background: #f3f4f6;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: var(--color-text-secondary, #9ca3af);
  font-size: var(--font-size-sm);

  .thumbnail_error-icon {
    font-size: 2rem;
  }
`;

export const ThumbnailDate = styled.div`
  padding: 8px 12px;
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary, #6b7280);
  background: #fff;
  border-top: 1px solid var(--color-border-primary, #e5e7eb);
  text-align: center;
`;

export const NoDataText = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 0;
  color: var(--color-text-secondary, #9ca3af);
  font-size: var(--font-size-base);
`;

export const EnlargeDialogImageWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
  border-radius: 8px;
  overflow: hidden;
  margin: 16px 0;
  height: 55vh;
  width: 100%;

  .enlarge-dialog_spinner {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .enlarge-dialog_error-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    color: #9ca3af;
    padding: 40px;
    cursor: default;

    .enlarge-dialog_error-icon {
      font-size: 3rem;
    }

    .enlarge-dialog_error-text {
      font-size: var(--font-size-sm);
    }
  }
`;

export const EnlargeDialogImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const EnlargeDialogModalWrapper = styled(Modal)`
  top: 5vh;

  .ant-modal-content {
    padding: 0;
    border-radius: 12px;
    box-shadow: 0px 2px 8px 0px rgba(5, 40, 97, 0.12);
    max-height: 90vh;
    display: flex;
    flex-direction: column;
  }

  .ant-modal-header {
    padding: 16px 24px;
    border-bottom: 1px solid var(--color-border-primary, #e5e7eb);
    margin-bottom: 0;
    flex-shrink: 0;

    .ant-modal-title {
      font-weight: var(--font-bold);
      font-size: var(--font-size-base);
    }
  }

  .ant-modal-body {
    padding: 20px 24px;
    overflow: hidden;
  }

  .enlarge-dialog_asset-info {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 4px;
  }

  .enlarge-dialog_info-row {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .enlarge-dialog_info-label {
    font-size: var(--font-size-sm);
    color: var(--color-text-secondary, #6b7280);
    font-weight: var(--font-medium);
    min-width: 80px;
  }

  .enlarge-dialog_info-value {
    font-size: var(--font-size-base);
    color: var(--color-text-primary, #111827);
    font-weight: var(--font-medium);
  }

  .enlarge-dialog_taken-at {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 4px;
  }
`;

export const EnlargeDialogFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid var(--color-border-primary, #e5e7eb);

  .enlarge-dialog_nav-buttons {
    display: flex;
    gap: 8px;
  }

  .ant-btn {
    height: 40px;
    min-width: 100px;
    font-weight: var(--font-medium);
    border-radius: 8px;
  }
`;
